module.exports = __webpack_public_path__ + "static/media/notfound.9a27f6a5.png";